import { useState } from "react";

import RemoveIcon from "../../../../components/RemoveIcon";
import Dialog from "./Dialog";

const RejectButton = ({ companyId, companyName }) => {
	const [open, setOpen] = useState(false);

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = (value) => {
		setOpen(false);
	};

	return (
		<>
			<RemoveIcon onClick={handleClickOpen} />
			<Dialog
				open={open}
				onClose={handleClose}
				companyId={companyId}
				companyName={companyName}
			/>
		</>
	);
};

export default RejectButton;
